import Component from '../site/Component';

/**
 * Component for lazy loading titles
 */
export default class LazyLoadTitles extends Component {

  /**
   * Start the component (called when Component is instantiated)
   */
  start() {
    this.element.addEventListener('isbnLoaded', (e) => {
      this.populateTitle(e.detail);
    });
  }

  /**
   * Given title data, populate the appropriate DOM nodes.
   *
   * @param {Object} data         Title data.
   * @param {string} data.title   The title's title.
   * @param {string} data.cover   The title's cover image, as an img tag.
   * @param {string} data.summary The title's summary.
   * @param {string} data.link    The title's permalink.
   * @param {string} data.price   The title's price.
   * @param {string} data.pubdate The title's pubdate.
   */
  populateTitle({ title = '', cover = '', summary = '', link = '',
  price = '', pubdate = '' }) {
    const titleEl = this.element.querySelector(this.elements.title);
    const coverEl = this.element.querySelector(this.elements.cover);
    const summaryEl = this.element.querySelector(this.elements.summary);
    const priceEl = this.element.querySelector(this.elements.price);
    const pubdateEl = this.element.querySelector(this.elements.pubdate);

    if (titleEl) {
      titleEl.textContent = title;
    }
    if (coverEl) {
      coverEl.innerHTML = cover;
    }
    if (summaryEl) {
      summaryEl.textContent =
        summary.replace('&hellip;', '...')
        .replace(/&nbsp;/g, ' ')
        .replace(/&#8203;/g, ' ');
    }
    if (priceEl) {
      priceEl.textContent = price;
    }
    if (pubdateEl) {
      pubdateEl.textContent = pubdate;
    }

    const links = this.element.querySelectorAll(this.elements.link);
    Array.prototype.forEach.call(links, (el) => {
      el.href = link; // eslint-disable-line no-param-reassign
    });
  }
}
